<template>
    <sys-register-base 
        :loading="loading" 
        @onSave="save" 
        :model.sync="model" 
        :title="title" 
        icon="mdi-book-open-page-variant" 
        v-bind:show.sync="dialog"
        maxWidth="40%"
    >
        <template v-slot:form>

            <!-- <div id="map"></div> -->
            <v-container>
                    <v-row>
                        <v-col cols="12" sm="12">
                            <sys-select-teacher
                                :model.sync="model.teacher_id"
                                :error="errors.teacher_id && errors.length > 0" 
                                :data.sync="model.teacher"
                                :errors="errors.teacher_id"
                                label="Professor*"
                                autoComplete
                                autofocus
                                clearable
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="12">
                            <sys-select-company
                                :model.sync="model.companies"
                                label="Empresa (Opcional)"
                                multiple
                                dense
                                select-all
                                filter-time-sheet
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col  cols="12" sm="8">
                            <sys-select-campus
                                :model.sync="model.campuses"
                                :error="errors.length > 0"  
                                :errors="errors.campuses"
                                label="Campus*"
                                only-active
                                multiple
                                select-all
                            />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <sys-select-shift
                                :model.sync="model.shifts"
                                :error="errors.length > 0"  
                                :errors="errors.shifts"
                                multiple
                                label="Turno*"
                                select-all
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="4">
                            <sys-select-occurrence-sheet-type
                                :model.sync="model.types"
                                :error="errors.length > 0"  
                                :errors="errors.types"
                                label="Tipo*"
                                dense
                                multiple
                            />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-text-field 
                                v-model="model.year" 
                                :error="errors.length > 0" 
                                :error-messages="errors.year" 
                                label="Ano*"
                                disabled
                                dense
                            />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <sys-select-month 
                                :model.sync="model.month"
                                dense
                                :error="errors.length > 0" 
                                :errors="errors.month" 
                                label="Mês*"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                            <v-col cols="12" sm="6">
                                <s-switch 
                                    v-model="model.consolidate_campuses"     
                                    text-helper='Consolidar todos os campus na folha de ponto' 
                                    label="Consolidar Campus"
                                    inset
                                />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <s-switch 
                                    v-model="model.consolidate_shifts"     
                                    text-helper='Consolidar todos os turnos na folha de ponto' 
                                    label="Consolidar Turno"
                                    inset
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="6">
                                <s-switch 
                                    v-model="model.include_ranges"     
                                    text-helper='Incluir intervalos' 
                                    label="Intervalo"
                                    inset
                                />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <s-switch 
                                    v-model="model.consolidade_dates"     
                                    text-helper='Consolidar horários por data' 
                                    label="Consolidar Datas"
                                    inset
                                />
                            </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6">
                                <s-switch 
                                    v-model="model.show_holidays"     
                                    text-helper='Exibir feriados no ponto do professor' 
                                    label="Exibir Feriado"
                                    inset
                                />
                            </v-col>
                    </v-row>
                    <v-row>
                        <!-- <v-col cols="12" sm="3">
                            <emc-calendar-date-picker2 
                                :model.sync="model.date_start" 
                                label="Data Início*"
                                :errorMessages="errors.date_start" 
                                :show="dialog"
                                :min="acesso.periodo.classes_start"
                                :max="acesso.periodo.classes_end"
                            />
                        </v-col>
                        <v-col cols="12" sm="3">
                            <emc-calendar-date-picker2 
                                :model.sync="model.date_end" 
                                label="Data Fim*"
                                :errorMessages="errors.date_end" 
                                :show="dialog"
                                :min="acesso.periodo.classes_start"
                                :max="acesso.periodo.classes_end"
                            />
                        </v-col> -->
                    </v-row>
            </v-container>
            <!-- Alert para mensagens -->
            <emc-alert-snackbar :show="!! message.length"  :message="message" :color="error ? 'error' : 'success'"/>
        </template>
       
    </sys-register-base>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
    name: "SysOccurrenceSheetRegister",
    data: (vm) => ({
        dialog: false,
        error: false,
        errors: {},
        message: '',
        loading: false,
    }),
    created(){
        
    },

    computed: {
      ...mapState('auth', ['acesso']),
    },

    watch: {
        
        dialog(dialog_new, dialog_old) {
            
            if(dialog_new !== dialog_old) {
                this.$emit('update:show', dialog_new)
            }

        },

        show(show_new, show_old) {
            
            this.dialog = show_new;
            
            if(show_new){
                this.error = false;
                this.errors = {};

                if(!this.model.id){
                    this.model.year         = this.acesso.periodo.year;
                    this.model.types        = [{ id: 1, name: 'Aula'}];
                    //this.model.date_start   = this.acesso.periodo.classes_start;
                    //this.model.date_end     = this.acesso.periodo.classes_end;
                }
            }
        },
        
    },
    props: {
        model: {
            default: null
        },
        color: {
            type: String,
            default: 'grey lighten-5'
        },
        width: {
            type: String,
            default: "500"
        },
        maxWidth: {
            type: String,
            default: "80%"
        },
        icon: {
            type: String,
            default: "mdi-alert"
        },
        title: {
            type: String,
            default: "Jornada de Trabalho"
        },
        text: {
            type: String,
            default: ""
        },
        show: {
            type: Boolean,
            default: false
        }
    },
    methods:{
        ...mapActions('timeSheet', ['ActionUpdateOccurrenceSheet', 'ActionStoreOccurrenceSheet']),

        save(edit)
        {
            this.error = false;
            this.message = '';
            this.loading = true;

            var payload = this.model;

            if(edit) {
                this.ActionUpdateOccurrenceSheet(payload)
                .then((res) => {
                    this.message = res.message;
                    this.$emit('onCompleted');
                })
                .catch((error) =>{
                    this.error      = true;
                    this.errors     = error.errors;
                    this.message    = error.message;
                })
                .finally(() => {
                     this.loading = false;
                })
            } else {
                this.ActionStoreOccurrenceSheet(payload)
                .then((res) => {
                    this.message = res.message;
                    this.$emit('onCompleted', res.data);
                })
                .catch((error) =>{
                    this.error      = error;
                    this.errors     = error.errors;
                    this.message    = error.message;
                })
                .finally(() => {
                   this.loading = false;
                })
            }

            
        },

    }
}
</script>